import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Library, OPTIONS } from '../library';

@Injectable({
  providedIn: 'root'
})
export class AccessService {

  constructor(private http: HttpClient) { }

  getAdmins() {
    return this.http.get<any>(Library.API_ENDPOINT + 'access/get_admins', OPTIONS);
  }

  getSupervisors() {
    return this.http.get<any>(Library.API_ENDPOINT + 'access/get_supervisors', OPTIONS);
  }

  getClientEmployees() {
    return this.http.get<any>(Library.API_ENDPOINT + 'access/get_client_employees', OPTIONS);
  }

  getSupervisorsPersonal() {
    return this.http.get<any>(Library.API_ENDPOINT + 'access/get_supervisors_personal', OPTIONS);
  }

  getAvailableAdmins() {
    return this.http.get<any>(Library.API_ENDPOINT + 'access/get_available_admins', OPTIONS);
  }

  getAvailableClientEmployees() {
    return this.http.get<any>(Library.API_ENDPOINT + 'access/get_available_clientEmployee', OPTIONS);
  }

  insertAdmin(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `access/admin_access/${id}`, OPTIONS);
  }

  deleteAdmin(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `access/delete_admin_access/${id}`, OPTIONS);
  }

  insertSupervisor(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `access/supervisor_access/${id}`, OPTIONS);
  }


  deleteSupervisor(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `access/delete_supervisor_access/${id}`, OPTIONS);
  }

  insertClientEmployee(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `access/client_access/${id}`, OPTIONS);
  }

  deleteClientAccess(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `access/delete_client_access/${id}`, OPTIONS);
  }

  getDepartments(id: any) {
    return this.http.get<any>(Library.API_ENDPOINT + `access/get_departments/${id}`, OPTIONS);
  }

  getDepartmentList(id: any) {
    return this.http.get<any>(Library.API_ENDPOINT + `access/get_department_list/${id}`, OPTIONS);
  }

  insertDepartmentAdmin(id: any, employeeId: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `access/insert_department/${id}/${employeeId}`, OPTIONS);
  }

  deleteDepartment(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `access/delete_department/${id}`, OPTIONS);
  }

  // branch
  getBranches(id: any) {
    return this.http.get<any>(Library.API_ENDPOINT + `access/get_branch/${id}`, OPTIONS);
  }

  getBranchList(id: any) {
    return this.http.get<any>(Library.API_ENDPOINT + `access/get_branch_list/${id}`, OPTIONS);
  }

  getClients(id: any) {
    return this.http.get<any>(Library.API_ENDPOINT + `access/get_clients/${id}`, OPTIONS);
  }

  getClientList(employeeId: any) {
    return this.http.get<any>(Library.API_ENDPOINT + `access/get_client_list/${employeeId}`, OPTIONS);
  }

  insertBranchAdmin(id: any, employeeId: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `access/insert_branch/${id}/${employeeId}`, OPTIONS);
  }

  insertClient(id: any, employeeId: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `access/insert_client/${id}/${employeeId}`, OPTIONS);
  }

  deleteBranch(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `access/delete_branch/${id}`, OPTIONS);
  }

  deleteClient(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `access/delete_client/${id}`, OPTIONS);
  }

  addMenuAccess(id: any, formList: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `access/add_menu_access/${id}`, formList, OPTIONS);
  }

  getMenuAccess(id: number) {
    return this.http.get<any[]>(Library.API_ENDPOINT + `access/get_menu_access/${id}`, OPTIONS);
  }

  getMyMenuAccess() {
    return this.http.get<any[]>(Library.API_ENDPOINT + `access/get_my_menu_access`, OPTIONS);
  }
}
